"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transformLabel = _interopRequireDefault(require("../utils/transformLabel"));

var _cropLabel = _interopRequireDefault(require("../utils/cropLabel"));

var _colorLabel = _interopRequireDefault(require("../utils/colorLabel"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    text-wrap: none;\n    white-space: nowrap;\n    word-wrap: normal;\n    ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _styledComponents["default"].label(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return (0, _colorLabel["default"])(props);
}, function (props) {
  return props.floating ? props.floatToFontSize : props.theme.fontSize;
}, function (props) {
  return props.floating ? props.floatToLineHeight : props.theme.lineHeight;
}, function (props) {
  return (0, _transformLabel["default"])(_objectSpread({}, props, {
    floatFromFontSize: props.theme.fontSize,
    floatFromLineHeight: props.theme.lineHeight
  }));
}, function (props) {
  return (0, _cropLabel["default"])(props.crop);
});

var _default = Root;
exports["default"] = _default;